/**
 * A short vibration when a swipe reaches its mark or a menu opens (spec D10), where the device allows it:
 * Android vibrates; iPhone web apps have no navigator.vibrate, and browsers may refuse without a recent tap.
 */
export function haptic(): void {
  try {
    navigator.vibrate?.(10)
  } catch {
    // Not allowed here.
  }
}
